namespace $.$$ {
	$mol_style_define( $shm_hitalama_text_embed_image, {
		pointerEvents: 'auto',
		Preview: {
			width: 'auto', height: 'auto',
			background: { color: 'transparent' },
		},
		Preview_image: {
			width: 'auto', height: 'auto', maxWidth: '100%',
		},
	} )
}
